import { render, staticRenderFns } from "./DynamicSvg.vue?vue&type=template&id=1f0f6ff7"
import script from "./DynamicSvg.vue?vue&type=script&lang=js"
export * from "./DynamicSvg.vue?vue&type=script&lang=js"
import style0 from "./DynamicSvg.vue?vue&type=style&index=0&id=1f0f6ff7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports